import * as React from 'react';
import * as styles from "./AppAdmin.css";
import { inject, observer } from 'mobx-react';
import { AppAdminStore } from './stores';
import InstanceService from '../../services/InstanceService';
import { IInstance } from '../../interfaces/IInstance';
import { LocalizationService } from '../../services/LocalizationService';
import { IAApp } from '../app/Index';
import { IACommandBar } from '../commandBar/CommandBar';
import { IAButton } from '../button/Button';
import { IAToggle } from '../toggle/Toggle';
import { ComponentEditPanel } from './componentEditPanel/ComponentEditPanel';
import { PageEditPanel } from './pageEditPanel/PageEditPanel';
import { DesignEditPanel } from './designEditPanel/DesignEditPanel';
import { SortPagesPanel } from './sortPagesPanel/SortPagesPanel';
import { Helper } from 'intraactive-sdk-helper';
import { IAPopup } from '../popup/Popup';

export interface IAppAdminProps {
  appAdminStore?: AppAdminStore;
  instanceName: string;
}

@inject('appAdminStore')
@observer
export class AppAdmin extends React.Component<IAppAdminProps> {

  private localizationService: LocalizationService = new LocalizationService();
  private cancelPopupId;
  private deletePopupId;

  constructor(props: IAppAdminProps) {
    super(props);
    this.getInstances(props.instanceName);
    this.props.appAdminStore.getTargetingApplication();
    this.cancelPopupId = Helper.getRandomStringKey();
    this.deletePopupId = Helper.getRandomStringKey();
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  componentWillReceiveProps(props: IAppAdminProps): void {
    if (props.instanceName !== this.props.instanceName) {
      this.getInstances(props.instanceName);
    }
  }

  private getInstances(instanceName: string): void {
    this.props.appAdminStore.loading = true;
    InstanceService.getInstances(this.props.appAdminStore.environment, this.props.appAdminStore.token, this.props.appAdminStore.tenant, "IntraActive-AppAdmin", true).then((instances: IInstance[]) => {
      if (instances && instances.length > 0) {
        instances.forEach((instance: IInstance) => {
          if (instance.instanceName === instanceName) {
            this.props.appAdminStore.instance = instance;
            if (instance && !instance.settings) {
              this.props.appAdminStore.instance.settings = {
                design: {
                  navigationBarColor: "#23879b",
                  navigationBarContentColor: "#ffffff",
                  logo: undefined,
                  icon: undefined,
                  tabBarColor: "#d9d9d9",
                  tabBarContentColor: "#ffffff",
                  tabBarHighlightColor: "#23879b",
                  menuStyle: "TabBar",
                  menuColor: "#e6e6e6",
                  menuContentColor: "#666666",
                  menuHighlightColor: "#23879b",
                  contentAreaColor: "#ffffff",
                  contentAreaContentColor: "#333333",
                  contentAreaHighlightColor: "#23879b"
                },
                menu: [],
                push: {
                  instances: []
                }
              }
            }
            this.props.appAdminStore.loading = false;
          }
          const temp = JSON.stringify(this.props.appAdminStore.instance);
          this.props.appAdminStore.instanceOriginal = Object.assign({}, JSON.parse(temp));
        });
      }
    });
  }

  private closePanels(): void {
    this.props.appAdminStore.editDesign = false;
    this.props.appAdminStore.editPage = false;
    this.props.appAdminStore.sortPages = false;
    this.forceUpdate();
  }


  private save(): Promise<void> {
    this.props.appAdminStore.isSaving = true;
    return new Promise<void>((resolve: () => void): void => {
      InstanceService.updateInstance(this.props.appAdminStore.environment, this.props.appAdminStore.token, this.props.appAdminStore.tenant, "IntraActive-AppAdmin", this.props.appAdminStore.instance).then((result: string) => {
        console.log(result);
        this.props.appAdminStore.isSaving = false;
        const temp = JSON.stringify(this.props.appAdminStore.instance);
        this.props.appAdminStore.instanceOriginal = Object.assign({}, JSON.parse(temp));
        this.props.appAdminStore.sortPages = false;
        this.props.appAdminStore.editDesign = false;
        this.props.appAdminStore.editPage = false;
        this.props.appAdminStore.editComponent = false;
        this.forceUpdate();
        resolve();
      });
    });
  }

  public render(): JSX.Element {
    let scale = 1.0;
    if (window.innerHeight < 948 && window.innerHeight >= 882) {
      scale = 0.9;
    } else if (window.innerHeight < 882 && window.innerHeight >= 805) {
      scale = 0.8;
    } else if (window.innerHeight < 805 && window.innerHeight >= 724) {
      scale = 0.7;
    } else if (window.innerHeight < 724) {
      scale = 0.6;
    }
    return (
      <>
        <div id={`deletePopupId_${this.deletePopupId}`}>
          {(this.props.appAdminStore.pageIndexToDelete !== undefined || this.props.appAdminStore.componentIndexToDelete !== undefined) &&
            <IAPopup
              headline={this.localizationService.strings.Messages_DeletePopup_Headline}
              content={
                <div>
                  <div
                    style={{
                      float: "left"
                    }}
                  >
                    {this.localizationService.strings.Messages_DeletePopup_Message}
                  </div>
                  <div
                    style={{
                      clear: "both",
                      float: "left"
                    }}
                  >
                    <IAButton
                      label={this.localizationService.strings.Messages_DeletePopup_Yes}
                      buttonColor={"#23879b"}
                      showSpinner={false}
                      onClick={() => {
                        if (this.props.appAdminStore.componentIndexToDelete !== undefined) {
                          this.props.appAdminStore.deleteComnponent().then(() => {
                            this.props.appAdminStore.componentIndexToDelete = undefined;
                            this.props.appAdminStore.selectedComponentIndex = undefined;
                            this.props.appAdminStore.showCancelEditPopup = false;
                            this.props.appAdminStore.checkForChanges();
                            document.body.style.overflowY = "auto";
                            document.body.style.height = "inherit";
                            this.forceUpdate();
                          });
                        }
                        if (this.props.appAdminStore.pageIndexToDelete !== undefined) {
                          this.props.appAdminStore.deletePage().then(() => {
                            this.props.appAdminStore.pageIndexToDelete = undefined;
                            this.props.appAdminStore.selectedComponentIndex = undefined;
                            this.props.appAdminStore.showCancelEditPopup = false;
                            this.props.appAdminStore.checkForChanges();
                            document.body.style.overflowY = "auto";
                            document.body.style.height = "inherit";
                            this.props.appAdminStore.selectedPageIndex = 0;
                            this.forceUpdate();
                            setTimeout(() => {
                              this.props.appAdminStore.reloadPage();
                            }, 100);
                          });
                        }
                      }}
                      style={{
                        marginTop: 20,
                        float: "left"
                      }}
                    />
                    <IAButton
                      label={this.localizationService.strings.Messages_DeletePopup_No}
                      buttonColor={"#999999"}
                      showSpinner={false}
                      onClick={() => {
                        this.props.appAdminStore.pageIndexToDelete = undefined;
                        this.props.appAdminStore.componentIndexToDelete = undefined;
                        this.props.appAdminStore.checkForChanges();
                      }}
                      style={{
                        marginTop: 20,
                        marginLeft: 10,
                        float: "left"
                      }}
                    />
                  </div>
                </div>
              }
              close={() => {
                this.props.appAdminStore.pageIndexToDelete = undefined;
                this.props.appAdminStore.componentIndexToDelete = undefined;
              }}
            />
          }
        </div>
        <div id={`cancelPopupId_${this.cancelPopupId}`}>
          {this.props.appAdminStore.showCancelEditPopup &&
            <IAPopup
              headline={this.localizationService.strings.Messages_CancelPopup_Headline}
              content={
                <div>
                  <IAButton
                    label={this.localizationService.strings.Messages_CancelPopup_Yes}
                    buttonColor={"#23879b"}
                    showSpinner={false}
                    onClick={() => {
                      this.props.appAdminStore.selectedComponentIndex = undefined;
                      this.props.appAdminStore.showCancelEditPopup = false;
                      this.props.appAdminStore.checkForChanges();
                      document.body.style.overflowY = "auto";
                      document.body.style.height = "inherit";
                      this.forceUpdate();
                    }}
                    style={{
                      marginTop: 20,
                      float: "left"
                    }}
                  />
                  <IAButton
                    label={this.localizationService.strings.Messages_CancelPopup_No}
                    buttonColor={"#999999"}
                    showSpinner={false}
                    onClick={() => {
                      this.props.appAdminStore.showCancelEditPopup = false;
                      this.props.appAdminStore.checkForChanges();
                    }}
                    style={{
                      marginTop: 20,
                      marginLeft: 10,
                      float: "left"
                    }}
                  />
                </div>
              }
              close={() => {
                this.props.appAdminStore.showCancelEditPopup = false;
              }}
            />
          }
        </div>
        <div id="IA_AppAdminCommandBar">
          <IACommandBar
            highlightColor={"#23879b"}
            leftSideContent={
              <div>
                <IAButton
                  label={this.localizationService.strings.AppAdmin_AddPage}
                  buttonColor="transparent"
                  textColor="#333333"
                  icon="Add"
                  height={22}
                  iconColor={"#23879b"}
                  fontSize={14}
                  onClick={() => {
                    this.props.appAdminStore.createNewPage();
                    this.closePanels();
                    this.props.appAdminStore.editPage = true;
                  }}
                  style={{ float: "left", marginTop: 5 }}
                />
                <IAButton
                  label={this.localizationService.strings.AppAdmin_EditItem}
                  buttonColor="transparent"
                  textColor="#333333"
                  icon={"Landingpage"}
                  height={22}
                  iconColor={"#23879b"}
                  fontSize={14}
                  onClick={() => {
                    let shouldOpenPanel = false;
                    if (!this.props.appAdminStore.editPage) {
                      shouldOpenPanel = true;
                    }
                    this.closePanels();
                    if (shouldOpenPanel) {
                      this.props.appAdminStore.editPage = true;
                    }
                  }}
                  style={{ float: "left", marginLeft: 20, marginTop: 5 }}
                  disbaled={this.props.appAdminStore.instance?.settings?.menu?.length === 0}
                />
                <IAButton
                  label={this.localizationService.strings.AppAdmin_Edit}
                  buttonColor="transparent"
                  textColor="#333333"
                  icon="Design"
                  height={22}
                  iconColor={"#23879b"}
                  fontSize={14}
                  onClick={() => {
                    let shouldOpenPanel = false;
                    if (!this.props.appAdminStore.editDesign) {
                      shouldOpenPanel = true;
                    }
                    this.closePanels();
                    if (shouldOpenPanel) {
                      this.props.appAdminStore.editDesign = true;
                    }
                  }}
                  style={{ float: "left", marginLeft: 20, marginTop: 5 }}
                />
                <IAButton
                  label={this.localizationService.strings.AppAdmin_SortPages}
                  buttonColor="transparent"
                  textColor="#333333"
                  icon="Reorder"
                  height={22}
                  iconColor={"#23879b"}
                  fontSize={14}
                  disbaled={this.props.appAdminStore.instance?.settings?.menu?.length < 2}
                  onClick={() => {
                    let shouldOpenPanel = false;
                    if (!this.props.appAdminStore.sortPages) {
                      shouldOpenPanel = true;
                    }
                    this.closePanels();
                    if (shouldOpenPanel) {
                      this.props.appAdminStore.sortPages = true;
                    }
                  }}
                  style={{ float: "left", marginLeft: 20, marginTop: 5 }}
                />
              </div>
            }
            rightSideContent={
              <div>
                <IAButton
                  label={this.localizationService.strings.AppAdmin_Save}
                  buttonColor="#23879b"
                  arialable="Save"
                  disbaled={!this.props.appAdminStore.hasChanged}
                  showSpinner={this.props.appAdminStore.isSaving}
                  onClick={() => {
                    this.save();
                  }}
                  style={{
                    float: "right"
                  }}
                />
                <IAButton
                  label={this.localizationService.strings.AppAdmin_Cancel}
                  buttonColor="gray"
                  arialable="Cancel"
                  disbaled={!this.props.appAdminStore.hasChanged}
                  showSpinner={this.props.appAdminStore.isSaving}
                  onClick={() => {
                    const temp = JSON.stringify(this.props.appAdminStore.instanceOriginal);
                    this.props.appAdminStore.instance = Object.assign({}, JSON.parse(temp));
                    this.props.appAdminStore.sortPages = false;
                    this.props.appAdminStore.editDesign = false;
                    this.props.appAdminStore.editPage = false;
                    this.props.appAdminStore.editComponent = false;
                  }}
                  style={{
                    float: "right",
                    marginRight: 20
                  }}
                />
                <div
                  style={{
                    float: "right",
                    marginRight: 40,
                    lineHeight: "31px",
                    fontSize: 14
                  }}
                >
                  {this.localizationService.strings.AppAdmin_UseAppSettings}
                </div>
                <IAToggle
                  checked={this.props.appAdminStore.instance?.settings?.useAppSettings}
                  onChange={() => {
                    if (this.props.appAdminStore.instance) {
                      this.props.appAdminStore.instance.settings.useAppSettings = !this.props.appAdminStore.instance?.settings.useAppSettings;
                    }
                    if (this.props.appAdminStore.instance?.settings.useAppSettings !== this.props.appAdminStore.instanceOriginal.settings.useAppSettings) {
                      this.props.appAdminStore.hasChanged = Helper.getRandomStringKey();
                    }
                    this.forceUpdate();
                  }}
                  style={{
                    float: "right",
                    clear: "none",
                    width: 50,
                    marginRight: 8,
                    marginTop: -3
                  }}
                  color={"#23879b"}
                />
              </div>
            }
            showBar={true}
            style={{
              borderBottom: "1px solid #eeeeee",
              padding: "10px 20px",
              boxSizing: "border-box",
              height: 50
            }}
          />
        </div>
        <div className={styles.IA_appAdmin}>
          <div
            className={styles.IA_simulator}
            id="IA_Simulator"
            style={{
              transform: `scale(${scale})`
            }}
          >
            <div className={styles.IA_simulatorScreen}>
              {this.props.appAdminStore.instance?.instanceName && this.props.appAdminStore.instance?.settings && this.props.appAdminStore.instance?.settings.design &&
                <IAApp
                  environment={this.props.appAdminStore.environment}
                  token={this.props.appAdminStore.token}
                  tenant={this.props.appAdminStore.tenant}
                  preview={true}
                  editMode={this.props.appAdminStore.editPage}
                  instance={this.props.appAdminStore.instance}
                  selectedPageIndex={this.props.appAdminStore.selectedPageIndex}
                  selectPage={(index) => {
                    this.props.appAdminStore.selectedPageIndex = index;
                  }}
                  previewSplashScreen={this.props.appAdminStore.previewSplashScreen != undefined}
                />
              }
              {this.props.appAdminStore.previewSplashScreen &&
                <div
                  className={styles.IA_splashScreen}
                  style={{
                    backgroundImage: `url('${this.props.appAdminStore.previewSplashScreen}')`
                  }}
                />
              }
            </div>
          </div>
        </div>
        <ComponentEditPanel
          open={this.props.appAdminStore.editComponent}
          hasChanged={() => this.forceUpdate()}
        />
        <PageEditPanel
          hasChanged={() => this.forceUpdate()}
        />
        <DesignEditPanel
          open={this.props.appAdminStore.editDesign}
          previewSplashScreen={this.props.appAdminStore.previewSplashScreen != undefined}
        />
        <SortPagesPanel
          open={this.props.appAdminStore.sortPages}
        />
      </>
    );
  }
}